import React from 'react';
import {withRouter} from 'react-router-dom';
import TabsLayout from '../components/TabsLayout';
import Payment from './tabs-contents/Payment';
import stepsTabs from '../config/tabs';
import {getCurrentTabIndex} from '../utils/routingHelpers';

const tabs = stepsTabs().offers;

class PaymentPage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.submit = this.submit.bind(this);
    this.setTab = this.setTab.bind(this);
  }

  componentDidMount() {
    this.setTab(this.props.location);
    this.unlisten = this.props.history.listen((location) => {
      this.setTab(location);
    });
  }

  submit() {
    sessionStorage.setItem('travel.allow-thank-you', 'true');
    this.props.history.push('/thank-you');
  }

  setTab(location) {
    const tabIndex = getCurrentTabIndex(location, 'offers');
    if (tabIndex === false) {
      return;
    }
    sessionStorage.setItem('travel.payment-tab', tabIndex);
  }

  componentWillUnmount() {
    this.unlisten();
  }

  render() {
    this.props.changeSideBar(true);
    const offer = JSON.parse(sessionStorage.getItem('travel.offerSelected'));
    // Keep the displayed agorot in sync with the Travel API's tokenization amount.
    const convertedPrice = offer.totalPriceShekel
      ? (Math.floor(Number.parseFloat(offer.totalPriceShekel) * 100) / 100).toFixed(2)
      : Number.parseFloat(offer.price * offer.currencyRate).toFixed(2);
    if (offer.convertedPrice !== convertedPrice) {
      offer.convertedPrice = convertedPrice;
      sessionStorage.setItem('travel.offerSelected', JSON.stringify(offer));
    }
    const initialTabs = JSON.parse(sessionStorage.getItem('travel.details-form'));
    const completeDetails = JSON.parse(sessionStorage.getItem('travel.complete-details'));

    return (
      <TabsLayout
        isTabsContainer={false}
        tabs={tabs}
        currentTabIndex={Number(sessionStorage.getItem('travel.payment-tab'))}
      >
        <Payment
          offer={offer}
          initialTabs={initialTabs.values}
          completeDetailsValues={completeDetails?.values}
          onBackToOffers={() => this.props.history.push('/offers')}
          submitAct={this.submit}
        />
      </TabsLayout>
    );
  }
}

export default withRouter(PaymentPage);
